// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CgJ0z","slide":"OY+28","featuredSlide":"bR3Bb","border":"eQAx5","control":"aGIJp","next":"GkscD"};